export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50 py-16">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-1">
            <span className="font-heading text-2xl text-background-50 block mb-4">91樱花</span>
            <p className="text-sm text-background-50/60 leading-relaxed">
              91樱花最新网址与最新入口 | 实时更新新地址，防封防失效，永久收藏访问动漫内容。致力于为广大漫迷提供最稳定可靠的动漫追番入口。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#updates" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">实时快讯</a>
              <a href="#ranking" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">热度榜单</a>
              <a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">主题索引</a>
              <a href="#faq" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">内容推荐</h4>
            <div className="flex flex-col gap-2">
              <a href="#carousel" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">焦点专题</a>
              <a href="#cards" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">精选推荐</a>
              <a href="#media" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">热门推荐</a>
              <a href="#topics" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">热门话题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              暂无合作伙伴展示，欢迎通过投稿合作邮箱与我们建立联系。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40 text-center sm:text-left">
            &copy; 2026 91樱花 - 最新网址与最新入口 | 实时更新 · 防封防失效 · 永久收藏
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">回到顶部</a>
            <a href="#contact" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}